'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../hooks/useMediaQuery/index.js');
var index$1 = require('../hooks/useWindowSize/index.js');
var _interface = require('./interface.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var QUERY_COLOR_SCHEME_DARK = '(prefers-color-scheme: dark)';
var QUERY_COLOR_SCHEME_LIGHT = '(prefers-color-scheme: light)';
var Theme = React.createContext({
  lang: 'en',
  dir: _interface.Vdir.LTR,
  mode: _interface.Vmode.LIGHT,
  color: _interface.Vcolor.BLUE,
  sidebar: _interface.Vsidebar.SHOW,
  fontFamily: _interface.VfontFamily.DEFAULT,
  fontSize: _interface.VfontSize.DEFAULT,
  setLang: null,
  setDir: null,
  setMode: null,
  setColor: null,
  setFontFamily: null,
  setFontSize: null,
  toggleMode: null,
  toggleSidebar: null
});
var useTheme = function () {
  return React.useContext(Theme);
};

function getMode() {
  if (window.matchMedia) {
    // wjdlz | NOTE: Check if the dark-mode Media-Query matches
    if (window.matchMedia(QUERY_COLOR_SCHEME_DARK).matches) {
      return _interface.Vmode.DARK;
    } else if (window.matchMedia(QUERY_COLOR_SCHEME_LIGHT).matches) {
      return _interface.Vmode.LIGHT;
    }
  } // wjdlz | NOTE: no-preference / hasNoSupport


  var hour = new Date().getHours();
  return hour < 6 || hour >= 18 ? _interface.Vmode.DARK : _interface.Vmode.LIGHT;
}

function getSidebarState() {
  return index$1.IsMobile() ? _interface.Vsidebar.HIDE : _interface.Vsidebar.SHOW;
}

var ThemeProvider = function (_a) {
  var children = _a.children;

  var _b = React.useState('en'),
      lang = _b[0],
      setLang = _b[1];

  var _c = React.useState(_interface.Vdir.LTR),
      dir = _c[0],
      setDir = _c[1];

  var _d = React.useState(_interface.Vmode.SYSTEM),
      mode = _d[0],
      setMode = _d[1];

  var _e = React.useState(_interface.Vcolor.BLUE),
      color = _e[0],
      setColor = _e[1];

  var _f = React.useState(_interface.VfontFamily.DEFAULT),
      fontFamily = _f[0],
      setFontFamily = _f[1];

  var _g = React.useState(_interface.VfontSize.DEFAULT),
      fontSize = _g[0],
      setFontSize = _g[1];

  var _h = React.useState(getSidebarState()),
      sidebar = _h[0],
      setSidebar = _h[1];

  var vthemeAttr = {
    lang: 'vlang',
    color: 'vcolor',
    fontFamily: 'vfont-family',
    fontSize: 'vfont-size',
    // wjdlz | NOTE: for custom data attr
    dir: 'vdir',
    mode: 'vmode',
    sidebar: 'vsidebar' // wjdlz | NOTE: based on | screen size, user preference

  };

  var getRoot = function () {
    var root = document.getElementsByTagName('html');
    return root[0];
  };

  React.useEffect(function () {
    getRoot().setAttribute(vthemeAttr.lang, lang);
  }, [lang]);
  React.useEffect(function () {
    getRoot().setAttribute(vthemeAttr.dir, dir);
  }, [dir]);
  React.useEffect(function () {
    var parsedMode = mode;

    if (mode == _interface.Vmode.SYSTEM) {
      parsedMode = getMode();
    }

    updateMode(parsedMode); // getRoot().setAttribute("vdata-theme-mode", mode);
  }, [mode]);
  React.useEffect(function () {
    updateColor(color);
  }, [color]);
  React.useEffect(function () {
    getRoot().setAttribute(vthemeAttr.fontFamily, fontFamily);
  }, [fontFamily]);
  React.useEffect(function () {
    getRoot().setAttribute(vthemeAttr.fontSize, fontSize);
  }, [fontSize]);
  React.useEffect(function () {
    getRoot().setAttribute(vthemeAttr.sidebar, sidebar);
  }, [sidebar]); // wjdlz | NOTE: custom hooks

  var isDarkMode = index["default"](QUERY_COLOR_SCHEME_DARK);
  React.useEffect(function () {
    if (mode !== _interface.Vmode.SYSTEM) {
      return;
    }

    updateMode(getMode());
  }, [isDarkMode]);
  React.useEffect(function () {
    var handler = function () {
      if (sidebar == _interface.Vsidebar.SHOW) {
        if (index$1.IsMobile()) {
          setSidebar(_interface.Vsidebar.HIDE);
        }
      }
    };

    window.addEventListener('resize', handler);
    return function () {
      return window.removeEventListener('resize', handler);
    };
  }, [sidebar]); // wjdlz | NOTE: custom operations

  var updateMode = function (mode) {
    var light = 'hsl(180, 5%, 95%)'; //wjdlz | NOTE: have to be in sync with variables.less

    var dark = 'hsl(210, 6%, 13%)'; //"hsl(0, 0%, 12%)";

    getRoot().setAttribute(vthemeAttr.mode, mode);
    document.querySelectorAll('meta[name=background-color]').forEach(function (el) {
      el.setAttribute('content', mode == _interface.Vmode.LIGHT ? light : dark);
    });
    document.querySelectorAll('meta[name=theme-color]').forEach(function (el) {
      el.setAttribute('content', mode == _interface.Vmode.LIGHT ? light : dark);
    });
  };

  var updateColor = function (color) {
    getRoot().setAttribute(vthemeAttr.color, color);
  };

  var toggleMode = function () {
    if (mode == _interface.Vmode.SYSTEM) {
      var parsedMode = _interface.Vmode.DARK;

      if (getRoot().getAttribute(vthemeAttr.mode) == _interface.Vmode.DARK) {
        parsedMode = _interface.Vmode.LIGHT;
      }

      updateMode(parsedMode);
    } else {
      setMode(mode == _interface.Vmode.DARK ? _interface.Vmode.LIGHT : _interface.Vmode.DARK);
    }
  };

  var toggleSidebar = function () {
    setSidebar(sidebar == _interface.Vsidebar.SHOW ? _interface.Vsidebar.HIDE : _interface.Vsidebar.SHOW);
  };

  return React__default["default"].createElement(Theme.Provider, {
    value: {
      lang: lang,
      dir: dir,
      mode: mode,
      color: color,
      sidebar: sidebar,
      fontFamily: fontFamily,
      fontSize: fontSize,
      setLang: setLang,
      setDir: setDir,
      setMode: setMode,
      setColor: setColor,
      setFontFamily: setFontFamily,
      setFontSize: setFontSize,
      toggleMode: toggleMode,
      toggleSidebar: toggleSidebar
    }
  }, children);
};

exports.ThemeProvider = ThemeProvider;
exports.useTheme = useTheme;
